module.exports = __webpack_public_path__ + "static/alaina-viau-social-media-c63b548bc48d52b73822b1a7a99907aa.jpg";